import * as React from 'react';
import ReactSVG from 'react-svg';

import './Icon.scss';

export interface IconProps {
  name: 'calendar-black' | 'add-file' | 'box' | 'delete' | 'down-chevron' | 'drain-accessories' 
    | 'edit-1' | 'edit-2' | 'garbage' | 'paint-palette' | 'save' 
    | 'settings' | 'user' | 'view' | 'wrench' | 'apron-backsplash' | 'chevron-left' | 'chevron-right' | 'duplicate-alt'
    | 'drain-accessories' | 'filter' | 'recesses-built-in-parts' | 'trough' | 'trough-pictogram'  | 'folder' | 'menu-dots' | 'double-chevron'
    | 'washbasin-dimensions' | 'box-view' | 'list-view' | 'plus' | 'plus-filled' | 'no-view' | 'rename' | 'close' | 'cross-roundel' | 'duplicate' | 'pdf' | 'archive' | 'lock';
  size?: 'small' | 'medium' | 'large';
}

export class Icon extends React.Component<IconProps, any> {
  public render() {
    const size = this.props.size ? this.props.size : 'medium';
    return this.svgFile ? (
      <div className={`icon icon-${this.props.name} icon-${size}`}>
        <ReactSVG src={this.svgFile} />
      </div>
    ) : null;
  }

  get svgFile(): string | undefined {
    switch (this.props.name) {
      case 'calendar-black':
        return require('src/assets/images/icons/calendar-black.svg');
      case 'add-file':
        return require('src/assets/images/icons/add-file.svg');
      case 'box':
        return require('src/assets/images/icons/box.svg');
      case 'delete':
        return require('src/assets/images/icons/delete.svg');
      case 'down-chevron':
        return require('src/assets/images/icons/down-chevron.svg');
      case 'drain-accessories':
        return require('src/assets/images/icons/drain-accessories.svg');
      case 'edit-1':
        return require('src/assets/images/icons/edit-1.svg');
      case 'edit-2':
        return require('src/assets/images/icons/edit-2.svg');
      case 'garbage':
        return require('src/assets/images/icons/garbage.svg');
      case 'paint-palette':
        return require('src/assets/images/icons/paint-palette.svg');
      case 'save':
        return require('src/assets/images/icons/save.svg');
      case 'settings':
        return require('src/assets/images/icons/settings.svg');
      case 'user':
        return require('src/assets/images/icons/user.svg');
      case 'view':
        return require('src/assets/images/icons/view.svg');
      case 'wrench':
        return require('src/assets/images/icons/wrench.svg');
      case 'apron-backsplash':
        return require('src/assets/images/icons/apron-backsplash.svg');
      case 'filter':
        return require('src/assets/images/icons/filter.svg');
      case 'recesses-built-in-parts':
        return require('src/assets/images/icons/recesses-built-in-parts.svg');
      case 'trough':
        return require('src/assets/images/icons/trough.svg');
      case 'trough-pictogram':
        return require('src/assets/images/icons/trough-pictogram.svg');
      case 'washbasin-dimensions':
        return require('src/assets/images/icons/washbasin-dimensions.svg');
      case 'box-view':
        return require('src/assets/images/icons/box-view.svg');
      case 'list-view':
        return require('src/assets/images/icons/list-view.svg');
      case 'plus':
        return require('src/assets/images/icons/plus.svg');
      case 'plus-filled':
        return require('src/assets/images/icons/plus-filled.svg');
      case 'no-view':
        return require('src/assets/images/icons/no-view.svg');
      case 'rename':
        return require('src/assets/images/icons/rename.svg');
      case 'close':
        return require('src/assets/images/icons/close.svg');
      case 'cross-roundel':
        return require('src/assets/images/icons/cross-roundel.svg');
      case 'duplicate':
        return require('src/assets/images/icons/duplicate.svg');
      case 'archive':
        return require('src/assets/images/icons/archive.svg');
      case 'pdf':
        return require('src/assets/images/icons/pdf.svg');
      case 'lock':
        return require('src/assets/images/icons/lock.svg');
      case 'folder':
        return require('src/assets/images/icons/folder.svg');
      case 'menu-dots':
        return require('src/assets/images/icons/menu-dots.svg');
      case 'double-chevron':
        return require('src/assets/images/icons/double-chevron.svg');
      case 'chevron-left':
        return require('src/assets/images/icons/chevron-left.svg');
      case 'chevron-right':
        return require('src/assets/images/icons/chevron-right.svg');
      case 'duplicate-alt':
        return require('src/assets/images/icons/duplicate-alt.svg');
      default:
        return undefined;
    }
  }
}
